





















































/* globals process */
import { EventBus } from '@/event-bus';
import { FormValidation, OpenHelp } from '@/mixins';
import { required, minLength } from 'vuelidate/lib/validators';
import { getContentArea } from '@/contentful';
import { FooterSecondary } from '@/components/global-components/global-footer-component/footer-components';
import { ExtendMixins } from '@/services';
import {
  MobileMenuTray,
} from '@/components/global-components/global-header-component/header-components';
import RegisterComponent from '@/components/auth-tools/registration/register.component.vue';

interface Data {
  clientName: string;
  learnLink: string;
}

export default ExtendMixins(
  FormValidation,
).extend({
  name: 'RegisterPage',
  data(): Data {
    return {
      clientName: process.env.VUE_APP_CLIENT_NAME,
      learnLink: '',
    };
  },
  beforeMount() {
    getContentArea(['global-learn-link']).then((data) => {
      const contentAreas = data;
      if (contentAreas) {
        if (contentAreas[0] && contentAreas[0].fields) {
          this.learnLink = contentAreas[0].fields.actionValue;
        }
      }
    });
  },
  methods: {
    backToLogin(): void {
      this.$router.push('login');
    },
    openMobileMenu() {
      EventBus.$emit('openMobileMenu');
    },
  },
  computed: {
    brand(): string {
      return this.clientName ? (this.clientName).replace(' ', '-').toLowerCase() : '';
    },
    brandPhone(): string {
      return this.$options.filters.t(`register-page-help-phone-${this.brand}`) ;
    },
  },
  components: {
    FooterSecondary,
    MobileMenuTray,
    RegisterComponent,
  },
});
